function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.27272 16.3636C6.38473 16.3727 5.52063 16.0761 4.82544 15.5236C4.57373 15.3183 4.45065 14.9943 4.50256 14.6737C4.55447 14.3531 4.77349 14.0845 5.07711 13.9692C5.38073 13.8538 5.72282 13.9092 5.97453 14.1145C6.34513 14.4026 6.80341 14.5547 7.27272 14.5454C8.25817 14.5454 9.0909 13.9217 9.0909 13.1817C9.0909 12.4417 8.25817 11.8181 7.27272 11.8181C5.39368 11.9326 3.77231 10.5139 3.63635 8.63628C3.77231 6.75868 5.39368 5.33999 7.27272 5.45447C8.1607 5.44532 9.0248 5.74192 9.71999 6.29447C10.1091 6.61178 10.1673 7.18445 9.84999 7.57356C9.53268 7.96267 8.96001 8.02087 8.5709 7.70356C8.2003 7.41547 7.74203 7.26335 7.27272 7.27265C6.28726 7.27265 5.45453 7.89628 5.45453 8.63628C5.45453 9.37628 6.28726 9.99992 7.27272 9.99992C9.15175 9.88544 10.7731 11.3041 10.9091 13.1817C10.7731 15.0593 9.15175 16.478 7.27272 16.3636Z",
  fill: "#32D882"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.27274 7.27284C6.77066 7.27284 6.36365 6.86582 6.36365 6.36375V4.54557C6.36365 4.04349 6.77066 3.63647 7.27274 3.63647C7.77482 3.63647 8.18183 4.04349 8.18183 4.54557V6.36375C8.18183 6.86582 7.77482 7.27284 7.27274 7.27284Z",
  fill: "#32D882"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.27274 18.1818C6.77066 18.1818 6.36365 17.7748 6.36365 17.2727V15.4545C6.36365 14.9524 6.77066 14.5454 7.27274 14.5454C7.77482 14.5454 8.18183 14.9524 8.18183 15.4545V17.2727C8.18183 17.7748 7.77482 18.1818 7.27274 18.1818Z",
  fill: "#32D882"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9091 9.09091H14.5455C13.5413 9.09091 12.7273 8.27688 12.7273 7.27273V0.909091C12.7273 0.407014 13.1343 0 13.6364 0C14.1385 0 14.5455 0.407014 14.5455 0.909091V7.27273H20.9091C21.4112 7.27273 21.8182 7.67974 21.8182 8.18182C21.8182 8.6839 21.4112 9.09091 20.9091 9.09091Z",
  fill: "#32D882"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.81818 29.0909H20C21.0042 29.0909 21.8182 28.2769 21.8182 27.2727V8.18182C21.8186 7.94055 21.7231 7.709 21.5527 7.53818L14.28 0.265457C14.1092 0.0950684 13.8776 -0.000428008 13.6364 2.89413e-06H1.81818C0.814028 2.89413e-06 0 0.814031 0 1.81818V27.2727C0 28.2769 0.814028 29.0909 1.81818 29.0909ZM1.81818 27.2727V1.81818H13.26L20 8.55818V27.2727H1.81818Z",
  fill: "#32D882"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2727 14.5455H13.6364C13.1343 14.5455 12.7273 14.1385 12.7273 13.6364C12.7273 13.1343 13.1343 12.7273 13.6364 12.7273H17.2727C17.7748 12.7273 18.1818 13.1343 18.1818 13.6364C18.1818 14.1385 17.7748 14.5455 17.2727 14.5455Z",
  fill: "#32D882"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2727 18.1817H13.6364C13.1343 18.1817 12.7273 17.7747 12.7273 17.2726C12.7273 16.7705 13.1343 16.3635 13.6364 16.3635H17.2727C17.7748 16.3635 18.1818 16.7705 18.1818 17.2726C18.1818 17.7747 17.7748 18.1817 17.2727 18.1817Z",
  fill: "#32D882"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2727 21.8182H4.54544C4.04337 21.8182 3.63635 21.4112 3.63635 20.9091C3.63635 20.407 4.04337 20 4.54544 20H17.2727C17.7748 20 18.1818 20.407 18.1818 20.9091C18.1818 21.4112 17.7748 21.8182 17.2727 21.8182Z",
  fill: "#32D882"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2727 25.4547H4.54544C4.04337 25.4547 3.63635 25.0476 3.63635 24.5456C3.63635 24.0435 4.04337 23.6365 4.54544 23.6365H17.2727C17.7748 23.6365 18.1818 24.0435 18.1818 24.5456C18.1818 25.0476 17.7748 25.4547 17.2727 25.4547Z",
  fill: "#32D882"
});

var SvgVenueManagment4 = function SvgVenueManagment4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment4.bc367918.svg";
export { ForwardRef as ReactComponent };